import { useEffect, useRef } from 'react';
import { loadStripe } from '@stripe/stripe-js';

import getConfig from '../util/config';

/**
 * Loads the Stripe API. Only to be used on high level views
 * in conjunction to stripe <Elements> component. Do not use in deeply nested components.
 *
 * @returns {null|Promise}
 */
const useStripePromise = () => {
  const stripePromise = useRef(null);
  const config = getConfig();

  useEffect(() => {
    stripePromise.current = loadStripe(config.stripe.key);
  }, []);

  return stripePromise.current;
};

export default useStripePromise;
